var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Dates")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_vm._v("Start Date to End Date")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86174fc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dateFilter.vue
// module id = EuHx
// module chunks = 1